import React from "react";
import { Link } from "react-router-dom";

const TONE = {
  solid: "bg-emerald-600 hover:bg-emerald-700 text-white",
  outline: "border border-border bg-background/60 hover:bg-muted text-foreground",
};

export const AlertAction = ({ to, tone = "solid", testid, children }) => (
  <Link to={to} data-testid={testid}
    className={`inline-flex items-center justify-center w-24 h-8 shrink-0 rounded-full text-xs font-medium whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring ${TONE[tone]}`}>
    {children}
  </Link>
);
